import { SnackBarPopupState } from "./type";

export const getShowSnackBarVisibility = (state: SnackBarPopupState) => state.isVisible;



// WEBPACK FOOTER //
// ./src/store/SnackBarPopup/selectors.ts